import Vue from 'vue'
import Router from 'vue-router'
import about from '@/components/about'
import service from '@/components/service'
import custom from '@/components/custom'
import docs from '@/components/docs'
import outsource from '@/components/outsource'
import root from '@/components/root'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'root',
      component: root
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/service',
      name: 'service',
      component: service
    },
    {
      path: '/custom',
      name: 'custom',
      component: custom
    },
    {
      path: '/docs',
      name: 'docs',
      component: docs
    },
    {
      path: '/outsource',
      name: 'outsource',
      component: outsource
    },
    {
      path: '/contact',
      name: 'contact',
      component: about
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js